import styled from '@emotion/styled';
import {
  Box,
  ColResponsive,
  Container,
  Hidden,
  RowResponsive,
} from '@landsbankinn/ui-kit';
import { type ReactNode } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { useApplicationServerContext, type LoginServerState } from 'src/state';
import {
  OperationalStatusComponentId,
  OperationalStatusEnum,
} from '../../../gql/__generated__/graphql';
import { useFetchOperationalStatus } from '../../Login/hooks/useFetchOperationalStatus';
import { Footer } from '../Footer';
import { TopNotification } from '../TopNotification';
import { Header } from './Header';
import { LandsbankinnOnlineBank } from './LandsbankinnOnlineBank';
import { MarketingArea } from './MarketingContent/MarketingArea';

function BaseContainerNotification() {
  const { operationalStatus } = useFetchOperationalStatus(
    OperationalStatusComponentId.LOGIN,
  );

  const hasAnyTopNotification =
    operationalStatus?.status === OperationalStatusEnum.DegradedPerformance ||
    operationalStatus?.status === OperationalStatusEnum.Info
      ? true
      : false;

  return (
    <>
      {operationalStatus && hasAnyTopNotification ? (
        <TopNotification {...operationalStatus} />
      ) : null}
    </>
  );
}

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  height: 100dvh;
`;

function DefaultDesktop(props: { children?: ReactNode }) {
  const { isXL } = useScreenSize();
  return (
    <StyledContainer color="blue font">
      <Header />
      <RowResponsive minHeight={isXL ? '178' : '56'} shrink="0">
        {/*The hidden block below is a workaround until ui-kit fixes WEB-42236*/}
        <Hidden xl>
          <ColResponsive md={0} lg={2}>
            {null}
          </ColResponsive>
        </Hidden>
        <ColResponsive md={12} lg={8} xl={12}>
          <Box width="480" marginLeft="auto" marginRight="auto">
            <BaseContainerNotification />
          </Box>
        </ColResponsive>
      </RowResponsive>
      <RowResponsive grow="0">
        {/*The hidden block below is a workaround until ui-kit fixes WEB-42236*/}
        <Hidden xl>
          <ColResponsive md={0} lg={2}>
            {null}
          </ColResponsive>
        </Hidden>
        <ColResponsive md={12} lg={8} xl={5}>
          <Box width="480" marginLeft="auto" marginRight="auto">
            {props.children}
          </Box>
        </ColResponsive>

        <ColResponsive xl={6} offset={{ xl: 1 }}>
          <MarketingArea />
        </ColResponsive>
      </RowResponsive>
      <Box grow="1" basis="0" shrink="1" />
      <RowResponsive>
        <ColResponsive mainAxisAlignment="center" crossAxisAlignment="center">
          <Footer />
        </ColResponsive>
      </RowResponsive>
    </StyledContainer>
  );
}

export function Desktop(props: { children?: ReactNode }) {
  const [context] = useApplicationServerContext() as [LoginServerState];

  const Container =
    context.isConsentFlow && context.landsbankiClient
      ? LandsbankinnOnlineBank
      : DefaultDesktop;

  return <Container>{props.children}</Container>;
}
